import React from 'react';
import './App.css';
import RiderTracking from './RiderTracking';

const App: React.FC = () => {
  return (
    <div className="App">
      <RiderTracking />
    </div>
  );
};

export default App;
